import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function LanguageSwitcher() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="fixed top-6 right-6 z-50 flex bg-[#1A1A1A]/80 backdrop-blur-sm border border-[#222] rounded-sm p-1 shadow-lg" data-id="element-43">
      <button onClick={() => setLang('cs')} className={`px-3 py-1.5 text-xs font-medium tracking-wider transition-colors duration-300 rounded-sm ${lang === 'cs' ? 'text-bg-primary bg-gold' : 'text-gray-400 hover:text-white'}`} data-id="element-44">
        CZ
      </button>
      <button onClick={() => setLang('en')} className={`px-3 py-1.5 text-xs font-medium tracking-wider transition-colors duration-300 rounded-sm ${lang === 'en' ? 'text-bg-primary bg-gold' : 'text-gray-400 hover:text-white'}`} data-id="element-45">
        EN
      </button>
    </div>;
}